import { CoreModel } from './core-model';
import { DomainModelCollection } from './domain-model-collection';
import { BaseIdentity } from './base-identity';


export class SearchResultlCollection<TItem extends CoreModel<TIdentity>, TIdentity extends BaseIdentity>
    extends DomainModelCollection<TItem, TIdentity> {

}
